export default "__VITE_ASSET__AX5EWpUp__"